import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(() =>
  createStyles({
    tableWrapper: {
      overflowY: 'auto',
      maxHeight: 490,
    },
    table: {
      '& .MuiTableCell-root.MuiTableCell-body': {
        '&:nth-child(2)': {
          textAlign: 'right',
          width: '100px',
        },
        '&:nth-child(3)': {
          width: '120px',
        },
      },
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 'none',
          },
        },
      },
    },
  }),
);
